import { render, staticRenderFns } from "./GoodsRecommend.vue?vue&type=template&id=6c246cfc&scoped=true&"
import script from "./GoodsRecommend.vue?vue&type=script&lang=js&"
export * from "./GoodsRecommend.vue?vue&type=script&lang=js&"
import style0 from "./GoodsRecommend.vue?vue&type=style&index=0&id=6c246cfc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c246cfc",
  null
  
)

export default component.exports